import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "copyFeeToAllInstallmentsButton",
    "credit",
    "creditDaysReceipt",
    "debitDaysReceipt",
    "creditDaysReceiptContainer",
    "creditReceiptType",
    "creditSection",
    "debitSection",
    "installmentsContainer",
    "installmentFee",
    "installmentsToRemove",
    "submitButton",
    "typeSelect",
  ];

  connect() {
    const niceSelectElements = $(".payment-fee__apply-nice-select")
    niceSelectElements.niceSelect();
    niceSelectElements.on("change", (event) => {
      event.currentTarget.dispatchEvent(new CustomEvent("custom-change", { bubbles: false }));
    });

    const typeSelectElement = $(this.typeSelectTarget)
    typeSelectElement.niceSelect();
    typeSelectElement.on("change", this.handlePaymentTypeChange.bind(this));

    if (typeSelectElement.val()) {
      this.togglePaymentTypeSections(typeSelectElement.val());
      this.updateRequired(typeSelectElement.val());
    } else {
      typeSelectElement.val("credit_debit").trigger("change").niceSelect('update')
    }
    this.toggleCreditReceiptType(this.creditReceiptTypeTarget.value);
  }

  handleValidation(e) {
    e.preventDefault();
    e.currentTarget.focus();
    e.currentTarget.classList.add('reveal-validation');
  }

  handlePaymentTypeChange(event) {
    this.updateRequired(event.target.value);
    this.togglePaymentTypeSections(event.target.value);
  }

  togglePaymentTypeSections(paymentType) {
    this.debitSectionTarget.classList.toggle("tw-hidden", paymentType == "credit" || !paymentType);
    this.creditSectionTarget.classList.toggle("tw-hidden", paymentType == "debit" || !paymentType);
  }

  handleCreditReceiptTypeChange(event) {
    this.toggleCreditReceiptType(event.target.value);
  }

  toggleCreditReceiptType(type) {
    this.element.setAttribute("data-credit-receipt-type", type);
    this.creditDaysReceiptContainerTarget.classList.toggle("tw-hidden", type === "" || type === "installments");
    this.creditDaysReceiptTarget.toggleAttribute("required", type === "once");
    this.installmentsContainerTarget.classList.toggle("tw-hidden", !type);
  }

  copyFeeToAllInstallments(){
    const firstInstallment = this.installmentFeeTargets[0];
    this.installmentFeeTargets.forEach((input) => {
      input.value = firstInstallment.value;
    })
  }

  removeInstallment(event){
    const parentElement = event.currentTarget.closest(".payment-fee-installment")
    if (parentElement.querySelector(".payment-fee-installment__id-input").value) {
      parentElement.querySelector(".payment-fee-installment__destroy-input").value = "true"
      parentElement.classList.add("tw-hidden")
      parentElement.classList.remove("payment-fee-installment")
      this.installmentsToRemoveTarget.insertAdjacentHTML('beforeend', parentElement.outerHTML);
    }

    parentElement.remove()
  }

  updateRequired(paymentType){
    this.element.querySelectorAll('[data-required="credit"]').forEach((input) => {
      input.toggleAttribute("required", paymentType == "credit" || paymentType == "credit_debit")
    })

    this.element.querySelectorAll('[data-required="debit"]').forEach((input) => {
      input.toggleAttribute("required", paymentType == "debit" || paymentType == "credit_debit")
    })
  }

  handleFocusInInstallment(event){
    event.currentTarget.parentElement.querySelector(".payment-fee-installment__remove-button").classList.add("payment-fee-installment__remove-button--active")
  }

  handleFocusOutInstallment(event){
    const parentElement = event.currentTarget.parentElement
    parentElement.querySelector(".payment-fee-installment__remove-button").classList.remove("payment-fee-installment__remove-button--active")
  }

  insertInstallment(event){
    const installments = this.element.querySelectorAll(".payment-fee-installment")
    let installmentHTML = installments[0].outerHTML
    installmentHTML = installmentHTML
      .split("payment_fee[payment_fee_installments_attributes][0]").join(`payment_fee[payment_fee_installments_attributes][${installments.length}]`)
      .replace("1x (taxa %)", `${installments.length + 1}x (taxa %)`)
    event.currentTarget.parentElement.insertAdjacentHTML('beforebegin', installmentHTML);

    const newInstallment = this.element.querySelectorAll(".payment-fee-installment")[installments.length]
    newInstallment
      .querySelector(".payment-fee-installment__number-input")
      .value = installments.length + 1
    const feeInput = newInstallment
      .querySelector(".payment-fee-installment__id-input")

    feeInput.value = null
    feeInput.dataset.installment = installments.length + 1
    newInstallment
      .querySelector(".payment-fee-installment__fee")
      .value = newInstallment.previousElementSibling
        .querySelector(".payment-fee-installment__fee")
        .value
  }

  handleFocusInInstallment(event){
    this.copyFeeToAllInstallmentsButtonTarget.classList.add("payment-fee-installment__copy-fee-to-all--visible")
  }

  handleFocusOutInstallment(event){
    this.copyFeeToAllInstallmentsButtonTarget.classList.remove("payment-fee-installment__copy-fee-to-all--visible")
  }
}
